module.exports = __webpack_public_path__ + "img/m2.0d327020.png";